/* global $ */
var order = false;
$(document).ready(function () {
	order = new cOrder();
});

function cOrder () {

	// Only run on /orders/ page.
	if (window.location.href.indexOf('/orders/') > -1) {
		this.onload();
	}
}

cOrder.prototype.onload = function () {
	window.onbeforeunload = this.confirmExit;

	this.fragment = window.location.hash.substr(1);
	if (this.fragment) {
		var formAction = $('#edit-order').attr('action');
		$('#edit-order').attr('action', formAction + '#' + this.fragment);
	}

	$('#edit-order').change(function () {
		$('#edit-order').data('changed', true);
	});
	$('.save').click(function (e) {
		window.onbeforeunload = null;
		$(this).attr('disabled', 'disabled');
		$('#edit-order').submit();
	});

	var self = this;
	this.orderId = $('#order_id').val();// get order id.
	var formElements = $(':input');
	$(formElements).click(function (e) { return self.submitEditOrderForm(this, e); });
	$('.delete-note').click(function (e) { return self.deleteNote(this, e); });
	// $('.save').click(function(e){this.disabled = true; this.value="Saving ...";})
	this.initTypeaheadFields();
	$('.nav-tabs').stickyTabs();
	$('#btn-mark-completed').click(function (e) {
		return self.toggleOrderCompleted(this, e);
	});

	this.$elOtherMethodChecked = $('#other_method_checked');
	this.$elOtherMethod = $('#other_method');

	this.$elOtherMethodChecked.click(function () { self.toggleOtherMethod(); });

	this.toggleOtherMethod();

	this.initFormURLAnchor();
	this.highlightErrors();
	this.initToggleUnknown();
	this.initToggleVoucher();
	this.initDelete();
	this.initExport();
	this.initCheckboxes();
	this.initBillingDate();

	this.initFieldHighlights();
};

cOrder.prototype.initFieldHighlights = function () { // .missing-data
	var self = this;
	this.elBillingRxReceived = $('#billing-rx-received');
	this.elBilingDocsFiled = $('#billing-docs-filed');
	this.elBillingRxReceivedWrapper = $('.billing-rx-received-w');

	$(this.elBilingDocsFiled).on('change', function () {
		self.updateFieldHighlights();
	});

	$(this.elBillingRxReceived).on('change', function () {
		self.updateFieldHighlights();
	});

	this.updateFieldHighlights();
};

cOrder.prototype.updateFieldHighlights = function () {
	var dateVal = this.elBillingRxReceived.val();
	var checkVal = this.elBilingDocsFiled.is(':checked');

	if (dateVal || checkVal) {
		this.elBillingRxReceivedWrapper.addClass('correct-data');
		this.elBillingRxReceivedWrapper.removeClass('missing-data');
	} else {
		this.elBillingRxReceivedWrapper.addClass('missing-data');
		this.elBillingRxReceivedWrapper.removeClass('correct-data');
	}
};

cOrder.prototype.toggleOtherMethod = function () {
	if (this.$elOtherMethodChecked.is(':checked')) {
		this.$elOtherMethod.show();
	} else {
		this.$elOtherMethod.hide();
	}
};

cOrder.prototype.submitEditOrderForm = function (el, e) {
	var self = this;
	var orderData = $('#edit-order');
	orderData['isAjax'] = 1;
	if ($('.olditem').length === 0 && $('.oldstocking').length === 0) {
		return;
	}
	orderData = $(':not(.newitem,.newstocking)', orderData);
	orderData = orderData.serialize();
	$.ajax({
		type: 'POST',
		url: '/orders/' + this.orderId,
		data: orderData,
		dataType: 'json',
		success: function (data) {
			self.messageReturned(data);
		},
		error: function (data) {
			self.errorReturned(data);
		}
	});
};

cOrder.prototype.toggleOrderCompleted = function (el, e) {
	e.preventDefault();
	if ($(el).data('is_complete') === 1) {
		$('<form action="/orders/' + this.orderId + '/completed/" method="get"></form>').appendTo('body').submit();
	} else {
		$('<form action="/orders/' + this.orderId + '/incomplete/" method="get"></form>').appendTo('body').submit();
	}
};

cOrder.prototype.messageReturned = function (data) {
	if ('message' in data) {
		$('#ajaxMessage').css('display', 'inline-block').removeClass().addClass('bg-success').html('<span class="fa fa-floppy-o" aria-hidden="true"></span> ' + data.message).fadeOut(3000);
	}
};
cOrder.prototype.errorReturned = function (data) {
	$('#ajaxMessage').css('display', 'inline-block').removeClass().addClass('bg-danger').html('<span class="fa fa-exclamation-triangle" aria-hidden="true"></span>Change invalid. Autosave failed.').fadeOut(5000);
};

cOrder.prototype.initTypeaheadFields = function () {
	var substringMatcher = function (strs) {
		return function findMatches (q, cb) {
			var matches, substrRegex;

			// an array that will be populated with substring matches
			matches = [];

			// regex used to determine if a string contains the substring `q`
			substrRegex = new RegExp(q, 'i');

			// iterate through the pool of strings and for any string that
			// contains the substring `q`, add it to the `matches` array
			$.each(strs, function (i, str) {
				if (substrRegex.test(str)) {
					matches.push(str);
				}
			});

			cb(matches);
		};
	};

	$('.vendor-name').typeahead({
		hint: true,
		highlight: true,
		minLength: 1
	}, {
		name: 'vendor-name',
		source: substringMatcher(vendor_names)
	});

	$('.insurance-co-a').typeahead({
		hint: true,
		highlight: true,
		minLength: 1
	}, {
		name: 'insurance-co',
		source: substringMatcher(insuranceCos)
	});
	$('.insurance-co-b').typeahead({
		hint: true,
		highlight: true,
		minLength: 1
	}, {
		name: 'insurance-co',
		source: substringMatcher(insuranceCos)
	});
	$('.insurance-co-c').typeahead({
		hint: true,
		highlight: true,
		minLength: 1
	}, {
		name: 'insurance-co',
		source: substringMatcher(insuranceCos)
	});
};

cOrder.prototype.highlightErrors = function () {
	for (var i = 0; i < error_keys.length; i++) {
		if (error_keys[i] === 'date_due') {
			$('#date_due').css('background', '#ffff99');
			continue;
		} else if (error_keys[i] === 'online_only') {
			$('#online-only').css('background', '#ffff99');
			continue;
		}
		var selector = error_keys[i];
		selector = selector.replace(/([a-zA-Z]+)\.([0-9]+)\.([a-zA-Z_]+)/, '$1\\[$2\\]\\[$3\\]');
		// selector = selector.replace(']','\\]');
		$('#' + selector).css('background', '#ffff99');
	}
};

cOrder.prototype.initToggleUnknown = function () {
	var sizes = $('[id*="\\[size\\]"]');
	// var widths = $('[id*="\\[width\\]"]');
	for (var i = 0; i < sizes.length; i++) {
		if ($(sizes[i]).val() > 0) {
			$(sizes[i]).siblings('checkbox').attr('disabled');
		} else {
		}
	}
};

cOrder.prototype.initToggleVoucher = function () {
	$('.select-itemtypeid').each(function () {
		name = $(this).attr('name');
		id = '#' + name.replace(/([a-zA-Z]+)\[([0-9]+)\]\[[a-zA-Z_]+\]/, '$1\\[$2\\]\\[voucher_amount\\]');
		if ($(this).val() == 3) {
			$(id).prop('disabled', false);
			$(id).show(500).siblings().show('500');
		} else {
			$(id).hide().siblings().hide();
		}
	});

	$('.select-itemtypeid').change(function () {
		name = $(this).attr('name');
		id = '#' + name.replace(/([a-zA-Z]+)\[([0-9]+)\]\[[a-zA-Z_]+\]/, '$1\\[$2\\]\\[voucher_amount\\]');
		if ($(this).val() == 3) {
			$(id).prop('disabled', false);
			$(id).show(500).siblings().show('500');
		} else {
			$(id).prop('disabled', true);
			$(id).val(0);
			$(id).hide(500).siblings().hide('500');
		}
	});
};

cOrder.prototype.initFormURLAnchor = function () {
	$('.nav-tabs li').click(function (e) {
		anchor = $(this).children('a').attr('href');
		url = $('#edit-order').attr('action');

		if (url.indexOf('#') == -1) {
			$('#edit-order').attr('action', url + anchor);
			return;
		}

		url = url.substring(0, url.indexOf('#'));
		$('#edit-order').attr('action', url + anchor);
	});
};

cOrder.prototype.initDelete = function () {
	$('#order-delete').click(function () {
		if (!confirm('Are you sure you want to delete this order?\n\nThis action cannot be undone.')) {
			return;
		}
		id = $(this).data('id');
		csrf = $('[name="csrf-token"]').attr('content');
		$('<form action="/orders/' + id + '" method="post"><input name="_method" type="hidden" value="DELETE"><input name="_token" type="hidden" value="' + csrf + '"></form>').appendTo('body').submit();
	});
	$('.item-delete').click(function () {
		if (!confirm('Are you sure you want to delete this item?')) {
			return;
		}
		id = $(this).data('item-id');
		csrf = $('[name="csrf-token"]').attr('content');
		$('<form action="/orderitems/' + id + '" method="post"><input name="_method" type="hidden" value="DELETE"><input name="_token" type="hidden" value="' + csrf + '"></form>').appendTo('body').submit();
	});
	$('.billing-item-delete').click(function () {
		if (!confirm('Are you sure you want to delete this payment?')) {
			return;
		}
		id = $(this).data('billing-item-id');
		orderId = $(this).data('order-id');
		csrf = $('[name="csrf-token"]').attr('content');
		$('<form action="/billingamounts/' + id + '" method="post"><input name="_method" type="hidden" value="DELETE"><input name="_token" type="hidden" value="' + csrf + '"><input type="hidden" name="order_id" value="' + orderId + '"></form>').appendTo('body').submit();
	});
};

cOrder.prototype.initExport = function () {
	$('#order-export').click(function () {
		id = $(this).data('id');
		window.location.href = '/orders/' + id + '/export';
	});
};

cOrder.prototype.initCheckboxes = function () {
	// payment checkboxes toggle.
	checkClasses = ['.est-when', '.est-who', '.bill-when', '.bill-who', '.bill-pay'];
	for (var i = 0; i < checkClasses.length; i++) {
		(function () { // closures in loops scope fix.
			var index = i;
			$(checkClasses[index]).change(function (e) {
				var checked = $(this).is(':checked');
				$(checkClasses[index]).prop('checked', false);
				if (checked) {
					$(this).prop('checked', true);
				}
			});
		})();
	}

	// Disable Rx received date if on file toggle
	$('#billing-docs-filed').change(function (e) {
		var checked = $(this).is(':checked');
		if (checked) {
			$('#billing-rx-received').val('').prop('disabled', true);
		} else {
			$('#billing-rx-received').prop('disabled', false);
		}
	});
};

cOrder.prototype.initBillingDate = function () {
	$('#billing-date').change(function (e) {
		$('#billing-a-date-sent').val($(this).val());
	});
};

cOrder.prototype.deleteNote = function (el, e) {
	var self = this;
	self.el = el;
	var noteData = {};
	noteData.id = $(el).data('noteId');
	noteData._token = $('[name="csrf-token"]').attr('content');
	noteData._method = 'DELETE';
	$.ajax({
		type: 'POST',
		url: '/orderitems/' + noteData.id + '/destroynote',
		data: noteData,
		dataType: 'json',
		success: function (data) {
			self.noteDeleted(data, el);
		},
		error: function (data) {
			self.errorReturned(data);
		}
	});
};

cOrder.prototype.noteDeleted = function (data, el) {
	if ('message' in data) {
		$('#ajaxMessage').css('display', 'inline-block').removeClass().addClass('bg-success').html('<span class="fa fa-check" aria-hidden="true"></span> ' + data.message).fadeOut(3000);
	}
	textareaName = $(el).data('textareaName');
	id = '#' + textareaName.replace(/([a-zA-Z]+)\[([0-9]+)\]\[[a-zA-Z_]+\]/, '$1\\[$2\\]\\[notes\\]');

	$(el).parent().html('<br><span class="text-danger">Note deleted.</span>');
	$(id).val('');
};

cOrder.prototype.confirmExit = function () {
	if ($('#edit-order').data('changed')) {
		// This message won't show in modern browsers, but the generic alert will fire.
		return 'Changes have been made to the data. if you continue those changes will be lost!';
	}
};
